module.exports = __webpack_public_path__ + "static/img/icon_identification_notarization_logo1.738390c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_identification_notarization_logo1.png
// module id = s0Qq
// module chunks = 1